import type { ApiBlockGridItemModel } from "#/_generated/umbraco/delivery-api/models";

export function shouldRenderBlockGridItem(item: ApiBlockGridItemModel) {
	const settings = item.settings?.properties as
		| {
				hideBlock?: boolean | null;
				publishStartDate?: string | null;
				publishEndDate?: string | null;
		  }
		| undefined;
	if (!settings) return true;
	if (settings.hideBlock) return false;
	const now = new Date();
	const start = settings.publishStartDate
		? new Date(settings.publishStartDate)
		: undefined;
	if (start && start > now) return false;
	const end = settings.publishEndDate
		? new Date(settings.publishEndDate)
		: undefined;
	if (end && end < now) return false;
	return true;
}
